var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgO(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.017,
    height: 23.692,
    viewBox: "0 0 28.017 23.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "o",
    transform: "translate(-2.25 -3.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(2.25 3.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M16.616,14.8a6.419,6.419,0,0,0,2.73.661h0a6.129,6.129,0,0,0,5.517-3.491,1.063,1.063,0,0,0-.115-1.106,1.111,1.111,0,0,0-1.034-.417A3.538,3.538,0,0,1,20.28,9.151a3.648,3.648,0,0,1-.043-4.21,1.059,1.059,0,0,0,.057-1.106,1.073,1.073,0,0,0-.948-.575,6.094,6.094,0,0,0-5.115,9.425,6.218,6.218,0,0,0,2.385,2.126Z",
    transform: "translate(2.55 -3.26)",
    fill: "#2772af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M25.784,15.426s-.043-.129-.057-.187a8.168,8.168,0,0,1-1.566.172h0A8.259,8.259,0,0,1,15.985,8.3,8.961,8.961,0,0,0,8.6,14.061a5.331,5.331,0,0,0-.963-.086,5.388,5.388,0,0,0,0,10.776H25.6a4.679,4.679,0,0,0,4.669-4.669,4.629,4.629,0,0,0-4.483-4.655Z",
    transform: "translate(-2.25 -1.059)",
    fill: "#2772af"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgO);
export default __webpack_public_path__ + "static/media/o.5eb1999aac927b13a8cece6cba4a78c4.svg";
export { ForwardRef as ReactComponent };